// extracted by mini-css-extract-plugin
export var closeIcon = "file-to-big-size-pill-module--close-icon--8A-EI";
export var folderWrapper = "file-to-big-size-pill-module--folder-wrapper--wU9S+";
export var pillText = "file-to-big-size-pill-module--pill-text--vjDF8";
export var wrapper = "file-to-big-size-pill-module--wrapper--Sx7cP";